<template>
<div class="greybg" :style="{minHeight: contentHeight}" style="
  background:rgba(247,248,250,1);">
  <div class='nodata'>
    <div><img src='@/assets/images/noExist.png' /></div>
    <div class='no-item-msg'>商品过期不存在</div>
  </div>
  
</div>
</template>
<script>
export default {
    name: '',
    data () {
        return {
          contentHeight:0,
        }
    },
    components:{
     
    },
    computed:{
       
    },
    mounted(){
      
    },
    created(){
        window.addEventListener('resize', this.getHeight);
        this.getHeight()
    },
    methods: {
        getHeight(){
            this.contentHeight = document.documentElement.clientHeight + "px";
        },
      
    }
}
</script>
<style scoped>
.nodata{
  text-align: center;
  padding: 20% 0;
}
.nodata img{
  width: 5.3333rem;
}
.no-item-msg{
  font-size:0.3467rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  text-align: center;
  line-height: 1.4;
}

</style>
